import { convertLatexToMarkup } from 'mathlive';

import MathBlot from '~shared/components/quill/blot/MathBlot';

import { processDomNodes } from './dom-utils';

const selector = `${MathBlot.tagName}.${MathBlot.className}`;

const wrapLatex = (s: string) => {
  const start = s.slice(0, 2);
  const end = s.slice(-2);
  if (end === '$$' && start === '$$') return s;

  return '$$' + s + '$$';
};

const stripFormula = (element: HTMLElement) => {
  const latex = element.getAttribute('data-latex') ?? element.textContent;
  element.textContent = wrapLatex(latex);
};

const addFormula = (element: HTMLElement) => {
  const latex = element.getAttribute('data-latex') ?? element.textContent;
  element.innerHTML = convertLatexToMarkup(latex, {
    mathstyle: 'displaystyle',
  });
};

const stripAllFormulas = processDomNodes({
  selector: selector,
  domAction: stripFormula,
});

const addAllFormulas = processDomNodes({
  selector: selector,
  domAction: addFormula,
});

export { stripAllFormulas, addAllFormulas, wrapLatex };
